import ABOName from "../../../components/ABOProfile/ABOName/ABOName";
import { storedLocale } from "../../Authentication/util";
import defaultContent from "../../../content/ssiUplineReport";
import { useTranslation } from "react-i18next";
import ABOPhoneNumber from "../../../components/ABOProfile/ABOPhoneNumber/ABOPhoneNumber";
import ABOEmail from "../../../components/ABOProfile/ABOEmail/ABOEmail";

type Props = {
  abo: {
    affNo: string;
    aboNo: string;
    name: string;
    localName: string;
    isoLanguageCode: string;
    privacyFlag: boolean;
    primaryNumber: string;
    email: string;
  };
  type: "abo" | "sponsor";
};

export default function SSIUplineAboDetails(props: Props) {
  const { abo, type } = props;
  const { t } = useTranslation(["ssiUplineReport"]);
  const applicantTrackOnclick = (clickAction: string) => {
    // add tealium tracking code
  };

  return (
    <div className="SSIUplineProfile__Section">
      <div className="SSIUplineProfile__NameSection">
        <div className="SSIUplineProfile__Type">
          {t("profileModal." + type, defaultContent["profileModal"][type]).toString()}:{" "}
        </div>
        <div className="SSIUplineProfile__Name">
          <ABOName
            name={abo.name}
            localName={abo.localName}
            privacyFlag={abo.privacyFlag}
            languageCode={abo.isoLanguageCode}
            locale={storedLocale()}
          />
        </div>
        <div> | </div>
        <div className="SSIUplineProfile__Number">#{abo.aboNo}</div>
      </div>
      <div className="SSIUplineProfile__DetailsSection">
        <ABOPhoneNumber
          primaryNumber={abo.primaryNumber}
          privacyFlag={abo.privacyFlag}
          applicantTrackOnclick={applicantTrackOnclick}
        />
      </div>
      <div className="SSIUplineProfile__DetailsSection">
        <ABOEmail email={abo.email} privacyFlag={abo.privacyFlag} applicantTrackOnclick={applicantTrackOnclick} />
      </div>
    </div>
  );
}
